import { createSelector } from 'reselect';
//////////////////////////////////////////////////

export const getReportSelectors = (reducerName) => {
  const store = (state) => state[reducerName];

  const makeSelectReportStatus = () => createSelector(
    store,
    (state) => state.reportPending,
  );

  const makeSelectAvailableReports = () => createSelector(
    store,
    ({ availableReports }) => availableReports,
  );

  const makeSelectUsedReport = () => createSelector(
    store,
    ({ usedReport }) => usedReport,
  );

  const makeSelectFilterParams = () => createSelector(
    store,
    ({ filterParams }) => filterParams,
  );

  const makeSelectItemList = () => createSelector(
    store,
    ({ itemList }) => itemList,
  );

  const makeSelectListType = () => createSelector(
    store,
    ({ listType }) => listType,
  );

  const makeSelectPagination = () => createSelector(
    store,
    ({ pagination }) => pagination,
  );

  const makeSelectTotalCount = () => createSelector(
    store,
    ({ totalCount }) => totalCount,
  );

  const makeSelectListLoading = () => createSelector(
    store,
    ({ loading }) => loading,
  );

  const makeSelectTableTitleFilters = () => createSelector(
    store,
    ({ tableTitleFilters }) => tableTitleFilters,
  );

  const makeSelectTitleSortValues = () => createSelector(
    store,
    ({ titleSortValues }) => titleSortValues,
  );

  const makeSelectPageVisited = () => createSelector(
    store,
    ({ pageVisited }) => pageVisited,
  );

  return {
    store,
    makeSelectItemList,
    makeSelectListType,
    makeSelectUsedReport,
    makeSelectPagination,
    makeSelectTotalCount,
    makeSelectPageVisited,
    makeSelectListLoading,
    makeSelectReportStatus,
    makeSelectFilterParams,
    makeSelectTitleSortValues,
    makeSelectAvailableReports,
    makeSelectTableTitleFilters,
  };
};
